<template>
    <div class="open-bt-layer">
        <div class="top-ele">
            <!-- <img class='pct100' :src="btOpenImg" alt=""> -->
            <JrmcBaseImg class='pct100' :src="btOpenImg"></JrmcBaseImg>
            <a class="open-bt-btn" clstag="A05R|clk_jh_active" :style="`top:${topRem}`"
               :href="btOpenJumpUrl"></a>
        </div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    .open-bt-layer {min-height: 100vh;background: #1B0084;}
    .open-bt-btn {position: absolute;left: 50%;margin-left: -1.59rem;width: 3.19rem;height: 0.72rem;background-image: url(../assets/images/open-bt-btn.png);@include singleBg;display: block;animation: flashs 0.8s infinite ease-in-out forwards;
        &:active {background-image: url(../assets/images/open-bt-btn-active.png);animation: none;}
        }
    .top-ele {position: relative;}
    @keyframes flashs {
        0% {transform: scale(0.98)}
        50% {transform: scale(1)}
        100% {transform: scale(0.98)}
        }
</style>
<script type="javascript">
    //Global
    import Global from './../scripts/Global'

    export default {
        data() {
            return {
                btOpenImg: '//img30.360buyimg.com/jr_image/jfs/t1/144182/8/1103/506093/5eec32feE2e6e6d52/e70e89d7d83d5f142.png',
                btOpenJumpUrl: 'https://bt.jd.com/v3/mobile/rGuide_initGuideMobile?channelName=102000172050&recommend=ZTCPS112000205507',
                topRem: "4.7rem"
            }
        },
        mounted() {
            if (Global.btOpenData && Global.btOpenData.templateData) {
                // console.log(Global.btOpenData.templateData)
                let targetImgUrl = Global.btOpenData.templateData.imgUrl;
                targetImgUrl = targetImgUrl.replace(/jfs/ig, 's750x5000_jfs');
                this.btOpenImg = targetImgUrl;
                try {
                    if (Global.btOpenData.templateData.jumpData.jumpUrl) {
                        this.btOpenJumpUrl = Global.btOpenData.templateData.jumpData.jumpUrl
                    }
                    if (Global.btOpenData.templateData['btn-top-rem']) {
                        this.topRem = Global.btOpenData.templateData['btn-top-rem']
                    }
                } catch (e) {

                }
            }
        }
    }
</script>
